import { init, showReportDialog } from '@sentry/browser';
import { BrowserTracing } from '@sentry/tracing';

export function sentryInit(
  isProd: boolean,
  buildNumber: string | undefined,
  tracesSampler?: (samplingContext: {
    transactionContext?: { op?: string };
  }) => number | boolean
) {
  if (isProd) {
    const release = `screencorder@${buildNumber ?? 0}`;
    init({
      dsn: 'https://12f4f25496fd4313ad9fa12286cc4fba@o241437.ingest.sentry.io/4504640361594880',
      integrations: [new BrowserTracing()],
      tracesSampler,
      beforeSend(event, hint) {
        if (event?.extra?.noFeedback === true) {
          return event;
        }

        if (event.exception) {
          showReportDialog({ eventId: event.event_id });
        }

        return event;
      },
      autoSessionTracking: true,
      release,
      // tunnel: '/skildvagt/tunnel',
    });
  }
}
